export default __webpack_public_path__ + "static/media/Linkedin-Celebrate.ffdc8a43.png";